import {SummaryImportTypes } from './actionTypes';

export type GetSummaryImportByWrNumberPayload = {
  pagination: { sizePerPage: number; page: number };
  filters?: { from: String; to: String; dynamicFilter: String };
};

export const getSummaryImport = (payload: GetSummaryImportByWrNumberPayload) => {
  return {
    type:SummaryImportTypes.GET_FILTER_LIST,
    payload,
  };
};

export const getSummaryImportSuccess = (payload: any) => {
  return {
    type:SummaryImportTypes.GET_FILTER_LIST_SUCCESS,
    payload,
  };
};
export const getSummaryImportError = (error: any) => {
    return {
      type:SummaryImportTypes.GET_FILTER_LIST_ERROR,
      payload: error,
    };
  };
  //------------------------------Filter-----------------------
export const getSummaryImportFilters = (payload?: { from?: string; to?: string }) => {
    return {
      type:SummaryImportTypes.GET_FILTERS,
      payload,
    };
  };
  
export const getSummaryImportFiltersSuccess = (payload: any) => {
  return {
    type:SummaryImportTypes.GET_FILTERS_SUCCESS,
    payload,
  };
};

export const getSummaryImportFiltersError = (error: any) => {
    return {
      type:SummaryImportTypes.GET_FILTERS_ERROR,
      payload: error,
    };
  };


